import instance from "./instance";

export const fetchFeedbacks = (page = 1) => {
  return async (dispatch) => {
    try {
      const res = await instance.post("/fetch_show_on_website_feedback/", {
        page: page,
      });
      dispatch({
        type: "FETCH_FEEDBACKS",
        payload: {
          feedbacks: res.data.feedbacks,
          pages_count: res.data.pages_count,
        },
      });
    } catch (err) {
      console.error(err);
    }
  };
};
